import "./MonthlySeoServices.module.css";
import Header from "@/reusable_sections/Header";
import MonthlyHero from "./sections/MonthlyHero";
import WhatsIncluded from "./sections/WhatsIncluded";
import OngoingSeo from "./sections/OngoingSeo";
import MonthlyCycle from "./sections/MonthlyCycle";
import TargetAdvantages from "./sections/TargetAdvantages";
import PricingTiers from "./sections/PricingTiers";
import RetainerFaq from "./sections/RetainerFaq";
import FinalCta from "./sections/FinalCta";
import Footer from "@/reusable_sections/Footer";
export default function MonthlySeoServicesPage() {
  return <div>
      <Header />
      <MonthlyHero />
      <WhatsIncluded />
      <OngoingSeo />
      <MonthlyCycle />
      <TargetAdvantages />
      <PricingTiers />
      <RetainerFaq />
      <FinalCta />
      <Footer />
    </div>;
}